





























































// import {
//   fetchStories
// } from '../api'
import StoryCardItem from "~/stories_widget/components/Stories/StoryCardItem.vue"
import StoryCardsWrapper from "~/stories_widget/components/Stories/StoryCardsWrapper.vue"
import {GetterTree, mapGetters} from 'vuex'
import Vue from 'vue'
// import {dragscroll} from 'vue-dragscroll'
import {dragscroll} from '~/stories_widget/components/dragscroll'
import {WidgetStoriesOptions} from "~/stories_widget/models/WidgetStoriesOptions";

import {emitEvent} from '~/stories_widget/util/event'
import {getTranslateValues} from '~/stories_widget/util/css'
import RootState from "~/stories_widget/store/rootState";
import {StoriesState, STORY_LIST_TYPE} from "~/stories_widget/store/vuex-stories-module";
import StoriesItem from "~/stories_widget/models/StoriesItem";
import {debug} from "~/stories_widget/util/debug";
import {Session} from "~/stories_widget/models/Session";
import AbstractModel from "~/stories_widget/models/AbstractModel";
import debounce from 'lodash/debounce'
import isFunction from 'lodash/isFunction'
import {needSession} from "~/stories_widget/util/env";
import {StoriesStatistic} from "~/stories_widget/components/StoriesStatistic";


function isNumeric(n: string | number): boolean {
    return !isNaN(parseFloat((<string>n))) && isFinite((<number>n));
}

const initThumbViews = (session: Session, viewport: HTMLElement) => {
    try {
        const viewportPositions = viewport.getBoundingClientRect();
        const viewportWidth = viewportPositions.x + viewportPositions.width;
        const positions: Map<number, number> = new Map();

        Array.prototype.slice.call(viewport.children).forEach((item) => {
            const id = parseInt(item.dataset['id']);
            const positionX = item.getBoundingClientRect().x;
            if (id) {
                positions.set(positionX, id);
            }
        });

        const scrollHandler = debounce((scrollLeft: number) => {
            const scrolledPosition = viewportWidth + scrollLeft;
            const newThumbViews: Array<number> = [];
            positions.forEach((id, position) => {
                if (!session.hasStoriesViewThumb(id)) {
                    if (position <= scrolledPosition) {
                        session.addStoriesViewThumb(id);
                        newThumbViews.push(id);
                    }
                }
            });

            session.flushThumbViews(newThumbViews);

            return;
        }, 1000, {leading: true});

        scrollHandler(0);

        return scrollHandler;

        // (scrollLeft + width) >= position - set read
        // if all readed - remove listener


    } catch (e) {
        console.error(e);
    }
};

let viewThumbsScrollHandler: ((scrollLeft: number) => void) | undefined;

const StoriesList = Vue.extend({
    name: "StoriesList",
    components: {StoryCardItem, StoryCardsWrapper},
    directives: {dragscroll},
    props: {
        loaded: {
            type: Boolean,
            default: () => false,
        }
    },
    data(): any {
        return {
            // displayedItems: this.$store.getters.activeStories,
            dragScrollStartAt: null,
            viewPortScrollLeft: 0,
            scrollPositionX: 0,
            thumbViewsHandlerInited: false,
            sessionInstance: null
        }
    },
    computed: {
        ...mapGetters('stories', {
            activeStoryIndex: 'activeStoryIndex',
            modeDesktop: 'modeDesktop',
        }),

        ...mapGetters('shared', { // связать с данными хранилища
            defaultLoadedStories: 'defaultLoadedStories',
            favoriteLoadedStories: 'favoriteLoadedStories',

            // options

            storiesListBottomMargin: 'storiesListBottomMargin',
            storiesListSidePadding: 'storiesListSidePadding',
            storiesListTopPadding: 'storiesListTopPadding',
            storiesListBottomPadding: 'storiesListBottomPadding',



            storiesBackgroundColor: 'storiesBackgroundColor',

            storiesGap: 'storiesGap',

            storiesHeight: 'storiesHeight',

            storiesBorderNotReadColor: 'storiesBorderNotReadColor',
            storiesBorderReadColor: 'storiesBorderReadColor',
            storiesListBorderNotReadWidth: 'storiesListBorderNotReadWidth',
            storiesListBorderReadWidth: 'storiesListBorderReadWidth',
            storiesListBorderGapNotRead: 'storiesListBorderGapNotRead',
            storiesListBorderGapRead: 'storiesListBorderGapRead',
            storiesListBorderRadius: 'storiesListBorderRadiusNotRead',
            storiesListBorderRadiusRead: 'storiesListBorderRadiusRead',

            withListControls: 'storiesListControls',
            storiesListControlsSize: 'storiesListControlsSize',
            storiesListControlsBackgroundColor: 'storiesListControlsBackgroundColor',
            storiesListControlsColor: 'storiesListControlsColor',

            storiesStyle: 'storiesStyle',

            sliderOptions: 'sliderOptions',

            session: 'session',
            sdkHasFavorite: 'hasFavorite',

            storiesListItemFavoriteOptions: 'storiesListItemFavoriteOptions',

        }),

        scrollLeftActive: function (): boolean {
            return this.viewPortScrollLeft > 0;

        },
        scrollRightActive: function (): boolean {
            const itemsWidth = Math.floor((parseFloat(this.getStoriesWidth()) + parseFloat(this.storiesGap)) * this.displayedItems.length) + 2 * parseFloat(this.storiesListSidePadding) - parseFloat(this.storiesGap);
            let viewPortWidth = 0;
            if (this.$refs.viewportInner !== undefined) {
                viewPortWidth = this.$refs.viewportInner.clientWidth;
            }
            return this.viewPortScrollLeft < (itemsWidth - viewPortWidth);
        },
        favoriteCell: function(): StoriesItem {
            const item = AbstractModel.createInstance(StoriesItem, {
                id: 0,
                title: this.storiesListItemFavoriteOptions.title.content,
                title_color: "black",
                is_opened: true,
                background_color: "white",
            });
            item.favorite_cell = true;

            return item;
        },
        displayedItems: function(): Array<StoriesItem> {
            const defaultLoadedStories: Array<StoriesItem> = this.defaultLoadedStories;
            if (this.sdkHasFavorite) {
                if (this.favoriteLoadedStories.length > 0 && defaultLoadedStories.length > 0) {
                    return [...defaultLoadedStories, this.favoriteCell];
                }
            }
            return defaultLoadedStories;
        },

        rootVars(): Dict<string> {
            // todo проверить - вызывается много раз
            let styles = {
                '--background-color': this.storiesBackgroundColor,

                'padding-left': this.storiesListSidePadding + 'px',
                'padding-right': this.storiesListSidePadding + 'px',
                'padding-top': this.storiesListTopPadding + 'px',
                'padding-bottom': this.storiesListBottomPadding + 'px',

                'background-color': this.storiesBackgroundColor,
            };
            return styles;
        },

    },
    watch: {
        activeStoryIndex: function (position, oldPosition) {
            if (this.$refs.viewportInner) {
                this.$refs.viewportInner.scrollLeft = ((parseFloat(this.getStoriesWidth()) + parseFloat(this.storiesGap)) * position);
            }
        },
        displayedItems: function (element, prevElement) {
            this.$nextTick(() => {
                if (this.$refs.viewportInner) {
                    if (!this.thumbViewsHandlerInited) {
                        this.thumbViewsHandlerInited = true;
                        viewThumbsScrollHandler = initThumbViews(this.sessionInstance, this.$refs.viewportInner);
                    }
                    if (!this.modeDesktop) {
                        /* Feature detection */
                        let passiveSupported = false;
                        try {
                            window.addEventListener(
                                "abort",
                                _ => _,
                                Object.defineProperty({}, "passive", {
                                    get: function () {
                                        passiveSupported = true;
                                    }
                                }) as EventListenerOptions);
                        } catch (err) {
                        }
                        this.$refs.viewportInner.addEventListener('scroll', this.viewPortOnScroll, passiveSupported ? {passive : true} as EventListenerOptions : false)
                    }
                }
            });
        }
    },
    provide: function (): any {
        return {
            reOrderItems: this.reOrderItems
        }
    },
    beforeMount() {
        this.sessionInstance = AbstractModel.createInstance(Session, this.session?.rawData);
    },
    beforeDestroy() {
        if (this.$refs.viewportInner !== undefined) {
            this.$refs.viewportInner.removeEventListener("scroll", this.viewPortOnScroll)
        }
    },
    methods: {
        viewPortOnScroll(): void {
            // for mobile native scroller
            if (this.$refs.viewportInner !== undefined) {
                this.viewPortScrollLeft = this.$refs.viewportInner.scrollLeft;
            }
            viewThumbsScrollHandler && viewThumbsScrollHandler(this.viewPortScrollLeft);
        },
        getStoriesWidth(): number {
            if (this.storiesStyle === WidgetStoriesOptions.STYLE_CIRCLE || this.storiesStyle === WidgetStoriesOptions.STYLE_QUAD) {
                return (1 * this.storiesHeight);
            } else if (this.storiesStyle === WidgetStoriesOptions.STYLE_RECTANGLE) {
                return (this.storiesHeight * .8);
            }
            return 0;
        },
        scrollLeft() {
            const position = 1;
            this.scrollPositionX = undefined;
            this.$nextTick(() => {
                this.scrollPositionX = 1 * ((parseFloat(this.getStoriesWidth()) + parseFloat(this.storiesGap)) * position);
                this.$nextTick(() => this.scrollPositionX = undefined);
            });

        },
        scrollRight() {
            const position = 1;
            this.scrollPositionX = undefined;
            this.$nextTick(() => {
                this.scrollPositionX = -1 * ((parseFloat(this.getStoriesWidth()) + parseFloat(this.storiesGap)) * position);
                this.$nextTick(() => this.scrollPositionX = undefined);
            });

        },
        slideWrapperStyle(index: number): object {
            let styles = {
                'margin-right': '0',
                'padding-left': '0',
                'padding-right': '0'
            };

            if (index !== this.displayedItems.length - 1) {
                styles['margin-right'] = this.storiesGap + 'px';
            } else {
                styles['padding-right'] = this.storiesListSidePadding + 'px'
            }

            if (index === 0) {
                styles['padding-left'] = this.storiesListSidePadding + 'px';
            }

            return styles;

        },
        onShowAll() {
            const id = this.$store.getters['stories/firstActiveStoryId'];
            this.$refs.viewportInner.scrollLeft = 0;
            this.$store.dispatch('stories/FETCH_STORY', id).then(() => this.$store.commit('stories/SET_ACTIVE_STORY', id));

            // fullScreen(document.querySelector('#app_bottom'))

        },

        reOrderItems() {
            // console.log('call reOrderItems')
        },
        scrollStart() {
            this.dragScrollStartAt = new Date();
        },
        scrollEnd(currentPosition: any) {
            this.viewPortScrollLeft = -1 * currentPosition.x;
            if (currentPosition.mouseup) {
                setTimeout(() => this.dragScrollStartAt = null, 100);
            }
            viewThumbsScrollHandler && viewThumbsScrollHandler(this.viewPortScrollLeft);
        },

        onStoryOpened(id: number) {
            if (!this.sessionInstance.hasStoriesViewThumb(id)) {
                this.sessionInstance.addStoriesViewThumb(id);
                this.sessionInstance.flushThumbViews([id]);
            }
        }

    }

});

export default StoriesList;


